import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './services/auth.service';
import { PasswordService } from './services/password.service';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { OauthComponent } from './oauth/oauth.component';
import { OauthAppComponent } from './oauth-app/oauth-app.component';
import { SsoComponent } from './sso/sso.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { AccountHoldComponent } from './account-hold/account-hold.component';
import { AccountSuspComponent } from './account-susp/account-susp.component';
import { AccountClosedComponent } from './account-closed/account-closed.component';
import { ErrorModule } from '../error/error-module';
import { AuthRoutingModule } from './auth-routing.module';
import { LayoutModule } from '../layout/layout.module';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UserInviteConsentComponent } from './user-invite-consent/user-invite-consent.component';
import { EmailChangeVerifyComponent } from './email-change-verify/email-change-verify.component';
import { LegacyUserInviteConsentComponent } from './legacy-user-invite-consent/legacy-user-invite-consent.component';
import { ProvisionService } from '../account/services/provision.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LayoutModule,
        AuthRoutingModule,
        SharedModule,
        NgbModalModule,
        ErrorModule,
    ],
    providers: [ AuthService, PasswordService, ProvisionService ],
    declarations: [
        AccountHoldComponent,
        LoginComponent,
        LogoutComponent,
        OauthComponent,
        OauthAppComponent,
        SsoComponent,
        ForgotPasswordComponent,
        AccountSuspComponent,
        AccountClosedComponent,
        PasswordResetComponent,
        VerifyEmailComponent,
        ResetPasswordComponent,
        UserInviteConsentComponent,
        LegacyUserInviteConsentComponent,
        EmailChangeVerifyComponent,
    ],
    entryComponents: [
        AccountClosedComponent,
        AccountHoldComponent,
        AccountSuspComponent,
        LoginComponent,
        LogoutComponent,
        OauthComponent,
        OauthAppComponent,
        SsoComponent,
        ForgotPasswordComponent,
        PasswordResetComponent,
        VerifyEmailComponent,
        ResetPasswordComponent,
        UserInviteConsentComponent,
        LegacyUserInviteConsentComponent,
        EmailChangeVerifyComponent,
    ]
})
export class AuthModule { }




